import React, { useMemo, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { TIMEPICKER_FORMAT } from 'utils/helpers/dateHelper'
import { AutoComplete } from 'antd'
import { StyledDownOutlined, StyledClockCircleOutlined } from './styled'
import { makeIntervalsArray } from './helpers'

const TimePicker = ({
  disabled = false,
  allowClear = true,
  onSelect,
  onChange = () => {},
  value: formValue,
  startMoment = dayjs(),
  blockBefore = true,
  assumeMidnight = false,
  dataTest = 'timePicker'
}) => {
  const options = useMemo(
    () => makeIntervalsArray({ startMoment, blockBefore, assumeMidnight }),
    [startMoment, blockBefore, assumeMidnight]
  )

  const defaultValue = useRef(null)

  useMemo(() => {
    if (formValue?.format) {
      options.forEach(({ label, value }) => {
        if (formValue.format(TIMEPICKER_FORMAT) === label) {
          defaultValue.current = value
        }
      })
    }
  }, [options])

  const [filteredOptions, setFilteredOptions] = useState(options)

  const onSearch = text =>
    setFilteredOptions(options.filter(i => i.label.includes(text)))

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <AutoComplete
        options={filteredOptions}
        disabled={disabled}
        allowClear={allowClear}
        placeholder="Time"
        onSelect={value => onSelect(value)}
        onChange={value => onChange(value)}
        showSearch={{ onSearch }}
        defaultValue={defaultValue.current}
        classNames={{ popup: { root: 'custom-timepicker' } }}
        data-test={dataTest}
        prefix={<StyledClockCircleOutlined />}
      />
      <StyledDownOutlined />
    </div>
  )
}

TimePicker.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  allowClear: PropTypes.bool,
  value: PropTypes.object, // dayjs object, handled by forms
  disabled: PropTypes.bool,
  startMoment: PropTypes.object, // dayjs object, passed manually
  blockBefore: PropTypes.bool, // block options before the startMoment
  assumeMidnight: PropTypes.bool, // if future, don't block any options
  dataTest: PropTypes.string
}

export default TimePicker
